<a href="https://design-tokens.io">
  <lib-brand-logo textColor="DARK"></lib-brand-logo>
</a>
